{
  "changePassword": "Сменить пароль",
  "changeUser": "Сменить пользователя",
  "description": "Пароль просрочен и должен быть заменен",
  "successMessage": "Пароль успешно изменен!"
}